export default "__VITE_ASSET__7cd62151__"